export default "__VITE_ASSET__BObTxRYz__"